module.exports = __webpack_public_path__ + "media/images/country_flags/kz-a666878f79f824dcade045ebf6a08cf4.png";